import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView, gtagPageView } from "@/lib/analytics";
import { HUMAN_VERIFIED_EVENT, isHumanVerified } from "@/lib/botDetection";

/**
 * Registra uma visualizacao de pagina a cada mudanca de rota, na captura
 * propria (Supabase) e no Google Analytics 4. Renderiza nada.
 * Deve ficar dentro do <BrowserRouter>.
 */
let firstRoute = true;

export function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    let sent = false;
    const isFirst = firstRoute;
    firstRoute = false;
    const send = () => {
      if (sent || !isHumanVerified()) return;
      sent = true;
      trackPageView(location.pathname);
      // O primeiro page_view já é enviado pelo config do gtag.js.
      if (!isFirst) gtagPageView(location.pathname);
    };

    send();
    window.addEventListener(HUMAN_VERIFIED_EVENT, send);
    return () => window.removeEventListener(HUMAN_VERIFIED_EVENT, send);
  }, [location.pathname]);

  return null;
}
